import { ItemListCard } from '@app/components/blocks/card/ItemListCard'
import { useTranslations } from '@i18n/useLanguage'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { useMemo } from 'react'

export const AmbassadorsCard = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage
  const [, setLocation] = useLocation()

  const items = useMemo(() => {
    const serviceProviders = (
      topicCommunity?.relatedServiceProviders ?? []
    ).map((sp) => ({
      id: `sp-${sp.id}`,
      title: sp.name,
      subtitle: sp.type?.[0]?.name,
      image: sp.avatar?.src,
      onClick: () => sp.slug && setLocation(pages.serviceProvider(sp.slug)),
    }))
    const municipalities = (topicCommunity?.relatedMunicipalities ?? []).map(
      (m) => ({
        id: `mun-${m.id}`,
        title: m.name,
        subtitle: t.municipality,
        image: m.avatar?.src,
        onClick: () => m.slug && setLocation(pages.municipalityPage(m.slug)),
      }),
    )
    return [...serviceProviders, ...municipalities]
  }, [
    topicCommunity?.relatedServiceProviders,
    topicCommunity?.relatedMunicipalities,
    setLocation,
    t.municipality,
  ])

  if (items.length === 0) {
    return null
  }

  return (
    <ItemListCard
      style={{ width: '100%' }}
      title={t.networksCard.title}
      items={items}
    />
  )
}
